import React from 'react';
import { motion } from 'framer-motion';

export default function TeaserBanner() {
  return (
    <section className="bg-etera-black flex flex-col items-center justify-center py-24 px-6">
      {/* Image Block */}
      <img
        src="https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvcG5n/001db030087ac5edfddf5a049d16123d.png"
        alt="Próximamente Teaser"
        className="w-full max-w-4xl object-contain mb-12"
      />
      
      {/* Text Element */}
      <motion.h2 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="text-etera-gold text-4xl md:text-5xl font-serif uppercase tracking-[0.3em] text-center"
      >
        PRÓXIMAMENTE
      </motion.h2>
    </section>
  );
}